module.exports = __webpack_public_path__ + "img/banner.2beb71d9.jpg";